var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idtr-block idtr-section"},[_c('div',{staticClass:"idtr-band"},[_vm._v(_vm._s(_vm.text.accountsTitle))]),_c('div',{staticClass:"idtr-section__body"},[_c('account-block',{attrs:{"index":0},on:{"remove":function($event){return _vm.$emit('remove', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }